<template>
    <div class="top-content">
        <div class="logo-area">
            <img src="/static/images/top/logo.png">
        </div>
        <div class="menu-area">
            <ul class="ul-menu">
                <li class="li-menu" :class="item.id == menu.checked ? 'checked':''" v-for="(item,index) in menu.data" :key="item.id" :index="index" 
                    @click="menuClick(item)" @mouseout="menuMouseOutEvent(item)" @mouseover="menuMouseOverEvent(item)">
                    {{item.title}}
                    <!-- <ul class="ul-menu-child" v-if="menu.checked == item.id && item.children != undefined">
                        <li class="li-menu-child" v-for="(child , i) in item.children" :key="i" @click="menuClildEvent(child)">{{child.title}}</li>
                    </ul> -->
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
export default {
    data(){
        return{
            menu:dataconfig.menu,
            currMenuindex:0,
            isWheel:false
        }
    },
    mounted(){
        let me = this;
        const height = $('.content-area').height();
        window.addEventListener('wheel',(e)=>{
            for(let i = 0;i < me.menu.data.length;i++){
                let item = me.menu.data[i];
                const elm = document.querySelector(`#${item.id}`);
                const clientRect = elm.getBoundingClientRect();
                let top = clientRect.top;
                if(e.deltaY > 0){
                    if(top < height / 2 && top > 0){
                        me.menu.checked = item.id;
                    }
                }
                else{
                    if(top < 0){
                       top = top * -1
                       if(top < height / 2){
                            me.menu.checked = item.id;
                       }
                    }else{
                        if(top < height / 2){
                            me.menu.checked = item.id;
                       } 
                    }
                }
            }
        });

        me.menuClick(me.menu.data[me.currMenuindex]);
        me.bus.$on("bottomMenuClick",(index) => {
            me.bottomMenuClick(index);
        });
    },
    methods:{
        bottomMenuClick(index){
            let me = this;
            let item = me.menu.data[index];
            me.menuClick(item); 
        },
        menuClick(item){
            let me = this;
            me.menu.checked = item.id;
            me.$emit("menuClick",item);
        },
        menuMouseOutEvent(item){
            let me = this;
            if(me.menu.checked == item.id && item.children != undefined && item.children.length > 0){
                $(".ul-menu-child").hide();
            }
        },
        menuMouseOverEvent(item){
            let me = this;
            if(me.menu.checked == item.id && item.children != undefined && item.children.length > 0){
                $(".ul-menu-child").show();
            }
        },
        menuClildEvent(item){
            let me = this;
            //me.$emit("menuClick",item);
            me.bus.$emit("scrollIntoView",item);
        }
    }
}
</script>
<style scoped>
    .top-content{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .logo-area{
        width: 30%;
        height: 100%;
        display: flex;
        align-items:center;
        margin-left:1rem;
        position: absolute;
        z-index: 0;
    }
    .logo-area img{
        width:160px;
    }
    .menu-area{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
        display: flex;
    }
    .menu-area .ul-menu{
        width: auto;
        height: 100%;
        min-width: 5%;
        list-style: none;
        margin:0 auto;
        padding:0;
    }
    .menu-area .ul-menu .li-menu {
        width: 100px;
        height: 100%;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 1rem;
        font-weight: bold;
        letter-spacing: 2px;
        position: relative;
        padding:0 20px;
        background: linear-gradient(to right,red,red) no-repeat right;
        background-size: 0 100%;
        transition:background-size 800ms , color 800ms;
        overflow: hidden;
    }
    .menu-area .ul-menu .li-menu:hover,.checked{
        color:#fff;
        background-position-x:left !important;
        background-size: 100% 100% !important;
    }
    
    .ul-menu-child{
        width: 130%;
        height: auto;
        position: absolute;
        list-style: none;
        margin: 0;
        padding: 0;
        color:#fff;
        background: #888;
        top:var(--head-height);
        z-index: 2;
    }
    .ul-menu-child .li-menu-child{
        width: 80%;
        height: 45px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #fff;
        font-size: 15px;
        cursor: pointer;
    }
    .ul-menu-child .li-menu-child:last-child{
        border-bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// src/view/page/head.vue